(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.TMPPartsFinderCore = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var PROFILE_VERSION = 1;

  function clean(value, maxLength) {
    return String(value == null ? '' : value).replace(/[\u0000-\u001F\u007F]/g, '').trim().slice(0, maxLength || 200);
  }

  function slug(value) {
    return clean(value, 120).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function unique(values, limit) {
    var seen = Object.create(null);
    return (Array.isArray(values) ? values : []).map(function (value) { return clean(value, 160); }).filter(function (value) {
      var key = value.toLowerCase();
      if (!value || seen[key]) return false;
      seen[key] = true;
      return true;
    }).slice(0, limit || 120);
  }

  function isSerialQualifiedModel(value) {
    return /(?:\bfrom\s+serial\b|\bserial\s*(?:no|number|range)?\b|\bs\s*\/\s*n\b|\b0[A-Z]\d{5,}\s*[-–]\s*0[A-Z]\d{5,}\b)/i.test(clean(value, 180));
  }

  function isProductLikeModel(value) {
    var code = clean(value, 220);
    if (!code || code.length > 90 || /_TO_|\b(?:19|20)\d{2}\s*[-–]\s*(?:19|20)\d{2}\b/i.test(code)) return true;
    if (/^0\d|^\d+(?:\.\d+)?L(?:\s+V\d.*)?$/i.test(code)) return true;
    if (/^(?:2|4)[-\s]?STROKE\b|\b\d+[-\s]*CYL(?:INDER)?\b|\b(?:MODEL\s+)?RANGE\b|\bSERIES\b/i.test(code)) return true;
    return /\b(?:ALTERNATOR|ASSEMBLY|BELT|BRACKET|CASTING|CRANKSHAFT|EXHAUST|GEARCASE|GASKET|HOSE|IMPELLER|JOINT|LOWER UNIT|OIL SEAL|PUMP|SCREW|SEAL KIT|TUBE|WATER PUMP|Y-PIPE|ARBRE|CORREA|EJE|PARAOLIO|TUBO)\b/i.test(code);
  }

  function mercruiserDriveIdentity(value) {
    var code = clean(value, 220).toUpperCase().replace(/[®™]/g, '').replace(/[_/]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!code || isProductLikeModel(code)) return null;
    var definitions = [
      { pattern: /^(?:MERCRUISER\s+)?ALPHA(?:\s+ONE)?\s+GEN(?:ERATION)?\s*(?:II|2|TWO)(?:\b|\s)/, family: 'Alpha One', version: 'Alpha One Gen II' },
      { pattern: /^(?:MERCRUISER\s+)?ALPHA(?:\s+ONE)?\s+GEN(?:ERATION)?\s*(?:I|1|ONE)(?:\b|\s)/, family: 'Alpha One', version: 'Alpha One Gen I' },
      { pattern: /^(?:MERCRUISER\s+)?ALPHA\s+ONE(?:\b|\s)/, family: 'Alpha One', version: '' },
      { pattern: /^(?:MERCRUISER\s+)?ALPHA(?:\b|\s)/, family: 'Alpha', version: '' },
      { pattern: /^(?:MERCRUISER\s+)?BRAVO\s*(?:1|I|ONE)\s*XR(?:\b|\s)/, family: 'Bravo One', version: 'Bravo One XR' },
      { pattern: /^(?:MERCRUISER\s+)?BRAVO\s*(?:1|I|ONE)\s*X(?:\b|\s)/, family: 'Bravo One', version: 'Bravo One X' },
      { pattern: /^(?:MERCRUISER\s+)?BRAVO\s*(?:1|I|ONE)(?:\b|\s)/, family: 'Bravo One', version: '' },
      { pattern: /^(?:MERCRUISER\s+)?BRAVO\s*(?:2|II|TWO)\s*XR(?:\b|\s)/, family: 'Bravo Two', version: 'Bravo Two XR' },
      { pattern: /^(?:MERCRUISER\s+)?BRAVO\s*(?:2|II|TWO)\s*X(?:\b|\s)/, family: 'Bravo Two', version: 'Bravo Two X' },
      { pattern: /^(?:MERCRUISER\s+)?BRAVO\s*(?:2|II|TWO)(?:\b|\s)/, family: 'Bravo Two', version: '' },
      { pattern: /^(?:MERCRUISER\s+)?BRAVO\s*(?:3|III|THREE)\s*XR(?:\b|\s)/, family: 'Bravo Three', version: 'Bravo Three XR' },
      { pattern: /^(?:MERCRUISER\s+)?BRAVO\s*(?:3|III|THREE)\s*X(?:\b|\s)/, family: 'Bravo Three', version: 'Bravo Three X' },
      { pattern: /^(?:MERCRUISER\s+)?BRAVO\s*(?:3|III|THREE)(?:\b|\s)/, family: 'Bravo Three', version: '' },
      { pattern: /^(?:MERCRUISER\s+)?BRAVO\s+FOUR\s+S(?:\b|\s)/, family: 'Bravo Four S', version: '' },
      { pattern: /^(?:MERCRUISER\s+)?BRAVO(?:\b|\s)/, family: 'Bravo', version: '' },
      { pattern: /^(?:MERCRUISER\s+)?BLACKHAWK(?:\b|\s)/, family: 'Blackhawk', version: '' },
      { pattern: /^(?:MERCRUISER\s+)?MC\s*-?\s*1(?:\b|\s)/, family: 'MC-1', version: '' },
      { pattern: /^(?:MERCRUISER\s+)?MR(?:\b|\s)/, family: 'MR', version: '' },
      { pattern: /^(?:MERCRUISER\s+)?TRS(?:\b|\s)/, family: 'TRS', version: '' }
    ];
    for (var i = 0; i < definitions.length; i += 1) {
      if (definitions[i].pattern.test(code)) return definitions[i];
    }
    return null;
  }

  function mercruiserEngineIdentity(value) {
    var raw = clean(value, 220);
    var code = raw.toUpperCase().replace(/[®™]/g, '').replace(/[_/]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!code || isProductLikeModel(raw) || mercruiserDriveIdentity(code)) return null;
    if (/^(?:F|FT)\d/i.test(code) || /^(?:L4|V6|V8|MCM|MPI)$/i.test(code)) return null;
    var qsd = code.match(/^QSD\s+(\d+(?:\.\d+)?)/i);
    if (qsd) return { family: 'QSD ' + qsd[1], version: code === ('QSD ' + qsd[1]).toUpperCase() ? '' : clean(value, 180) };
    var litre = code.match(/\b(\d{1,2}(?:\.\d+)?)\s*L(?=\b|[A-Z])/i)
      || code.match(/^(\d{1,2}(?:\.\d+)?)\s+(?:EFI|MPI|CARB|CARBURETOR)/i)
      || code.match(/^MX\s*(\d{1,2}(?:\.\d+)?)\s+(?:EFI|MPI)/i);
    if (litre) {
      var litreFamily = litre[1].replace(/^0+(?=\d)/, '') + 'L';
      return { family: litreFamily, version: code === litreFamily.toUpperCase() ? '' : clean(value, 180) };
    }
    var cid = code.match(/\b(\d{3})\s*CID\b/i);
    if (cid) return { family: cid[1] + ' CID', version: code === (cid[1] + ' CID') ? '' : clean(value, 180) };
    return { family: clean(value, 180), version: '' };
  }

  function groupModels(rows, context) {
    var application = clean(context && context.application, 120).toLowerCase();
    var manufacturer = clean(context && context.manufacturer, 120).toLowerCase();
    var restrictMercruiserDrives = (application.indexOf('stern') !== -1 || application.indexOf('outdrive') !== -1) && manufacturer.indexOf('mercruiser') !== -1;
    var restrictMercruiserEngines = application.indexOf('inboard') !== -1 && manufacturer.indexOf('mercruiser') !== -1;
    var source = (Array.isArray(rows) ? rows : []).filter(function (row) {
      if (!row) return false;
      var code = clean(row.model_code || row.model || row.ui_label, 220);
      if (!code || isSerialQualifiedModel(code)) return false;
      if (restrictMercruiserDrives) return Boolean(mercruiserDriveIdentity(code));
      if (restrictMercruiserEngines) return Boolean(mercruiserEngineIdentity(code));
      return !isProductLikeModel(code);
    });
    var codes = source.map(function (row) { return clean(row.model_code || row.model || row.ui_label, 180); });
    var normalizedCodes = codes.map(function (code) { return code.toLowerCase(); });

    function inferredFamily(row, code) {
      var explicit = clean(row.model_family || row.family_code || row.family, 140);
      if (explicit) return explicit;
      if (restrictMercruiserDrives) return mercruiserDriveIdentity(code).family;
      if (restrictMercruiserEngines) return mercruiserEngineIdentity(code).family;
      var candidates = codes.filter(function (possible, index) {
        if (normalizedCodes[index] === code.toLowerCase()) return false;
        if (code.toLowerCase().indexOf(possible.toLowerCase()) !== 0) return false;
        var next = code.slice(possible.length, possible.length + 1);
        return /^[-\s/]$/.test(next) || (/\d/.test(possible) && /^[a-z]$/i.test(next));
      }).sort(function (a, b) { return a.length - b.length; });
      if (candidates.length) return candidates[0];
      var numericVariant = code.match(/^([a-z]+\d+)[-\s/]+\d{2,4}(?:\b|[-\s/])/i);
      if (numericVariant) {
        var prefix = numericVariant[1];
        var siblings = codes.filter(function (item) { return new RegExp('^' + prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '[-\\s/]\\d{2,4}(?:\\b|[-\\s/])', 'i').test(item); });
        if (siblings.length > 1) return prefix;
      }
      var suffixVariant = code.match(/^([a-z][a-z0-9-]*?\d+)([a-z]{1,3}(?:-[a-z])?)$/i);
      if (suffixVariant) {
        var stem = suffixVariant[1];
        var sameStem = codes.filter(function (item) { return item.toLowerCase().indexOf(stem.toLowerCase()) === 0; });
        var knownVolvoStem = manufacturer.indexOf('volvo') !== -1 && /^(?:AD|AQ|D|KAD|MD|TAD|TAMD|TMD)\d/i.test(stem);
        if (sameStem.length > 1 || knownVolvoStem) return stem;
      }
      return code;
    }

    function rowIds(row) {
      return unique([row.canonical_equipment_id, row.equipment_id].concat(Array.isArray(row.equipment_ids) ? row.equipment_ids : []));
    }

    var groups = Object.create(null);
    source.forEach(function (row) {
      var code = clean(row.model_code || row.model || row.ui_label, 180);
      var familyCode = inferredFamily(row, code);
      var key = familyCode.toLowerCase();
      if (!groups[key]) groups[key] = { key: slug(familyCode), modelCode: familyCode, label: familyCode, rows: [], baseRows: [], variants: [] };
      groups[key].rows.push(row);
      if (code.toLowerCase() === familyCode.toLowerCase()) groups[key].baseRows.push(row);
    });

    return Object.keys(groups).map(function (key) {
      var group = groups[key];
      var variantMap = Object.create(null);
      var familyBaseIds = unique([].concat.apply([], group.baseRows.map(rowIds)));
      group.rows.forEach(function (row) {
        var code = clean(row.model_code || row.model || row.ui_label, 180);
        if (code.toLowerCase() === group.modelCode.toLowerCase()) return;
        var explicit = clean(row.variant_label || row.variant_code || row.variant, 160);
        var drive = restrictMercruiserDrives ? mercruiserDriveIdentity(code) : null;
        var engine = restrictMercruiserEngines ? mercruiserEngineIdentity(code) : null;
        var remainder = code.slice(group.modelCode.length).replace(/^[-\s/]+/, '');
        var primary = remainder.match(/^(\d{2,4})(?:\b|[-\s/])/);
        var label = explicit || (drive && drive.version) || (engine && engine.version) || (primary ? group.modelCode + '-' + primary[1] : code);
        if (drive && !drive.version) return;
        var variantKey = label.toLowerCase();
        if (!variantMap[variantKey]) variantMap[variantKey] = { key: slug(label), label: label, modelCode: label, rows: [], baseRows: [] };
        variantMap[variantKey].rows.push(row);
        if (code.toLowerCase() === label.toLowerCase()) variantMap[variantKey].baseRows.push(row);
      });
      group.variants = Object.keys(variantMap).map(function (variantKey) {
        var variant = variantMap[variantKey];
        var preferred = variant.baseRows[0] || variant.rows[0];
        variant.canonicalEquipmentId = clean(preferred.canonical_equipment_id || preferred.equipment_id, 160);
        variant.ownEquipmentIds = unique([].concat.apply([], variant.rows.map(rowIds)));
        variant.equipmentIds = unique(familyBaseIds.concat(variant.ownEquipmentIds));
        variant.categoryEquipmentIds = variant.equipmentIds.slice();
        return variant;
      }).sort(function (a, b) { return a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' }); });
      var preferred = group.baseRows[0] || group.rows[0];
      group.canonicalEquipmentId = clean(preferred.canonical_equipment_id || preferred.equipment_id, 160);
      group.equipmentIds = unique([].concat.apply([], group.rows.map(rowIds)));
      group.categoryEquipmentIds = unique([].concat.apply([], group.rows.map(rowIds)));
      group.hasVariants = group.variants.length > 0;
      return group;
    }).sort(function (a, b) { return a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' }); });
  }

  function applicationType(value) {
    var text = clean(value, 120).toLowerCase();
    if (text.indexOf('sail') !== -1 || text.indexOf('s-drive') !== -1) return 'saildrive';
    if (text.indexOf('stern') !== -1 || text.indexOf('outdrive') !== -1) return 'sterndrive';
    if (text.indexOf('generator') !== -1 || text.indexOf('genset') !== -1) return 'generator';
    if (text.indexOf('gearbox') !== -1 || text.indexOf('transmission') !== -1) return 'gearbox';
    if (text.indexOf('inboard') !== -1 || text.indexOf('outboard') !== -1 || text.indexOf('engine') !== -1) return 'engine';
    return 'application';
  }

  function terminology(application, strings) {
    var type = applicationType(application);
    var labels = {
      engine: {
        noun: 'engine',
        find: 'Find engine',
        save: 'Save this engine',
        use: 'Use engine details',
        saved: 'Engine saved to your account.'
      },
      generator: {
        noun: 'generator',
        find: 'Find generator',
        save: 'Save this generator',
        use: 'Use generator details',
        saved: 'Generator saved to your account.'
      },
      sterndrive: {
        noun: 'stern drive',
        find: 'Find stern drive',
        save: 'Save this stern drive',
        use: 'Use stern drive details',
        saved: 'Stern drive saved to your account.'
      },
      saildrive: {
        noun: 'saildrive',
        find: 'Find saildrive',
        save: 'Save this saildrive',
        use: 'Use saildrive details',
        saved: 'Saildrive saved to your account.'
      },
      gearbox: {
        noun: 'gearbox',
        find: 'Find gearbox',
        save: 'Save this gearbox',
        use: 'Use gearbox details',
        saved: 'Gearbox saved to your account.'
      },
      application: {
        noun: 'application',
        find: 'Find application',
        save: 'Save this application',
        use: 'Use application details',
        saved: 'Application saved to your account.'
      }
    };
    var output = Object.assign({}, labels[type]);
    var overrides = strings && strings.terminology && strings.terminology[type];
    if (overrides) output = Object.assign(output, overrides);
    output.type = type;
    return output;
  }

  function sanitizeProfile(profile) {
    var equipmentIds = Array.isArray(profile && profile.equipmentIds) ? profile.equipmentIds : [];
    var cleanIds = unique(equipmentIds, 120);
    var categoryIds = unique(profile && profile.categoryEquipmentIds, 40);
    var application = clean(profile && profile.application, 120);
    var make = clean(profile && profile.make, 100);
    var model = clean(profile && profile.model, 140);
    var canonicalId = clean(profile && (profile.canonicalEquipmentId || profile.equipmentId), 160);
    if (canonicalId && cleanIds.indexOf(canonicalId) === -1) cleanIds.unshift(canonicalId);
    return {
      version: PROFILE_VERSION,
      id: clean(profile && profile.id, 100) || ['tmp', slug(application), slug(make), slug(model), Date.now()].filter(Boolean).join('-'),
      name: clean(profile && profile.name, 160) || [make, model].filter(Boolean).join(' '),
      application: application,
      applicationKey: clean(profile && profile.applicationKey, 80),
      equipmentType: applicationType(application),
      make: make,
      model: model,
      modelFamily: clean(profile && profile.modelFamily, 140) || model,
      variant: clean(profile && profile.variant, 140),
      isBroadMatch: Boolean(profile && profile.isBroadMatch),
      displayName: clean(profile && profile.displayName, 180) || [make, model].filter(Boolean).join(' '),
      canonicalEquipmentId: canonicalId,
      equipmentIds: cleanIds,
      categoryEquipmentIds: categoryIds.length ? categoryIds : canonicalId ? [canonicalId] : [],
      savedAt: clean(profile && profile.savedAt, 40) || new Date().toISOString()
    };
  }

  function validProfile(profile) {
    var item = sanitizeProfile(profile);
    return Boolean(item.application && item.make && item.model && item.canonicalEquipmentId);
  }

  function storageAdapter(storage, key, limit) {
    var storageKey = clean(key, 120) || 'tmp-parts-finder.applications';
    var maximum = Math.max(1, Math.min(Number(limit) || 8, 20));

    function read() {
      if (!storage || typeof storage.getItem !== 'function') return [];
      try {
        var parsed = JSON.parse(storage.getItem(storageKey) || '[]');
        if (!Array.isArray(parsed)) return [];
        return parsed.map(sanitizeProfile).filter(validProfile).slice(0, maximum);
      } catch (error) {
        return [];
      }
    }

    function write(profiles) {
      if (!storage || typeof storage.setItem !== 'function') return false;
      storage.setItem(storageKey, JSON.stringify(profiles.slice(0, maximum)));
      return true;
    }

    function save(profile) {
      var item = sanitizeProfile(profile);
      if (!validProfile(item)) return { ok: false, reason: 'invalid', profiles: read() };
      var profiles = read();
      var index = profiles.findIndex(function (existing) {
        return existing.canonicalEquipmentId === item.canonicalEquipmentId;
      });
      if (index === -1 && profiles.length >= maximum) return { ok: false, reason: 'limit', profiles: profiles };
      if (index === -1) profiles.unshift(item);
      else profiles.splice(index, 1, Object.assign({}, profiles[index], item, { id: profiles[index].id }));
      try {
        write(profiles);
        return { ok: true, profile: item, profiles: profiles };
      } catch (error) {
        return { ok: false, reason: 'storage', profiles: profiles };
      }
    }

    function replace(profiles) {
      var cleaned = (Array.isArray(profiles) ? profiles : []).map(sanitizeProfile).filter(validProfile).slice(0, maximum);
      try {
        write(cleaned);
        return cleaned;
      } catch (error) {
        return read();
      }
    }

    return { read: read, save: save, replace: replace };
  }

  function rowsFrom(data, keys) {
    if (Array.isArray(data)) return data;
    for (var i = 0; i < keys.length; i += 1) {
      if (data && Array.isArray(data[keys[i]])) return data[keys[i]];
    }
    return [];
  }

  function safeEndpoint(value, origin) {
    var input = clean(value, 500);
    if (!input) return '';
    try {
      var parsed = new URL(input, origin || 'https://example.invalid');
      if (parsed.protocol !== 'https:' && parsed.origin !== origin) return '';
      return parsed.href.replace(/\/$/, '');
    } catch (error) {
      return '';
    }
  }

  return {
    PROFILE_VERSION: PROFILE_VERSION,
    applicationType: applicationType,
    clean: clean,
    groupModels: groupModels,
    isProductLikeModel: isProductLikeModel,
    isSerialQualifiedModel: isSerialQualifiedModel,
    rowsFrom: rowsFrom,
    safeEndpoint: safeEndpoint,
    sanitizeProfile: sanitizeProfile,
    storageAdapter: storageAdapter,
    terminology: terminology,
    validProfile: validProfile
  };
});